


import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { createClient } from '@supabase/supabase-js';

// ---------------- SUPABASE ----------------
const SUPABASE_URL =
  process.env.REACT_APP_ENQUIRY_SUPABASE_URL;
const SUPABASE_KEY =
  process.env.REACT_APP_ENQUIRY_SUPABASE_ANON_KEY ||
  process.env.REACT_APP_ENQUIRY_SUPABASE_SERVICE_ANON_KEY
const supabase = SUPABASE_URL && SUPABASE_KEY ? createClient(SUPABASE_URL, SUPABASE_KEY) : null;

// ---------------- COMPONENT ----------------
const NewsPage = () => {
  const [dbArticles, setDbArticles] = useState([]);
  const [showMore, setShowMore] = useState(false);

  // Fetch articles from Supabase
  useEffect(() => {
    const fetchArticles = async () => {
      if (!supabase) {
        console.error(
          'Missing Supabase env vars. Set REACT_APP_ENQUIRY_SUPABASE_URL and REACT_APP_ENQUIRY_SUPABASE_ANON_KEY (or fallback REACT_APP_SUPABASE_URL / REACT_APP_SUPABASE_ANON_KEY).'
        );
        return;
      }

      const { data } = await supabase
        .from('articles')
        .select('id, title, description')
        .order('id', { ascending: false });

      if (data) setDbArticles(data);
    };

    fetchArticles();
  }, []);

  // Function to remove HTML tags from the article description
  const removeHtmlTags = (text) => {
    return text.replace(/<\/?[^>]+(>|$)/g, ""); // Regex to remove all HTML tags
  };

  // Toggle View More / View Less
  const toggleShowMore = () => setShowMore(!showMore);


  return (
    <div id="news-page">
      {/* ---------------- NAVBAR ---------------- */}
      <nav className="navbar navbar-expand-lg navbar-light bg-dark shadow-sm">
        <div className="container">
          <Link to="/" className="navbar-brand">
            <img
              src="/image/Glogo.png"
              alt="Company Logo"
              style={{ height: '50px', marginRight: '10px' }}
            />
          </Link>

          <button className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto mx-auto">
              <li className="nav-item">
                <Link
                  to="/"
                  className="nav-link text-light"
                  style={{ fontSize: '1.2rem', fontWeight: 'bold' }}
                >
                  News & Information
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      {/* ---------------- HEADER ---------------- */}
      <div className="container text-center my-5">
        <h3 style={{ fontSize: '1.4rem', color: '#de1829ff', fontWeight: 'bold' }}>Information</h3>
        <p style={{ color: '#555', fontSize: '1.1rem', marginBottom: '20px' }}>
          <strong style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#000' }}>
            Read our latest articles
          </strong>
          <br />
          Discover a wide range of content, from how-to articles to the latest news and information.
        </p>
      </div>

      {/* ---------------- ARTICLES ---------------- */}
      <div className="container my-5">
        <div className="row">
          {dbArticles.slice(0, showMore ? dbArticles.length : 3).map((article, index) => (
            <div key={index} className="col-md-4 mb-4">
              <div className="card shadow-lg border-0 rounded-3" style={{ backgroundColor: 'white', minHeight: '450px' }}>
                <div className="card-body d-flex flex-column" style={{ height: '100%' }}>
                  {/* Logo Section */}
                  <div className="text-center mb-4">
                    <img
                      src="/image/Glogo.png"
                      alt="Company Logo"
                      style={{ height: '120px', marginBottom: '30px' }} // Adjusted spacing for logo
                    />
                  </div>

                  {/* Article Title */}
                  <h5 className="card-title mb-3" style={{ color: '#de1829ff', fontSize: '1.2rem' }}>
                    {article.title}
                  </h5>

                  {/* Article Description */}
                  <p className="card-text" style={{ color: '#333', fontSize: '1rem' }}>
                    {removeHtmlTags(article.description)?.slice(0, 120) + '...'}
                  </p>

                  {/* Read More Button */}
                  <Link
                    to={`/article-detail-page?id=${article.id}`}
                    className="btn btn-dark"
                    style={{
                      backgroundColor: '#000',
                      color: 'white',
                      padding: '10px',
                      fontSize: '1rem',
                      width: '100%',
                      textAlign: 'center',
                      display: 'block',
                      borderRadius: '5px',
                      marginTop: 'auto', // Ensures the button stays at the bottom
                    }}
                  >
                    Read More
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* ---------------- VIEW MORE / LESS ---------------- */}
        <div className="text-center mt-4">
          <button className="btn btn-outline-dark btn-lg" onClick={toggleShowMore}>
            {showMore ? "View Less" : "View More"}
          </button>
        </div>
      </div>

      {/* ---------------- FOOTER ---------------- */}
      <footer className="bg-dark text-white py-2 mt-3">
        <div className="container text-center">
           <div className="row mt-3">
          <div className="col-12 text-center small">
            &copy; {new Date().getFullYear()} Grey Imports. All rights reserved.
            <span className="mx-2">|</span> {/* ✅ ADDED: separator */}
            <a
              className="text-reset text-decoration-none"
              href="https://www.mdlreports.com.au/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
         </footer>
         </div>
  );
};

export default NewsPage;

